import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ThumbaCoin } from "@roman/shared/components/Icons";
import LoadingSpinner from "@roman/shared/components/LoadingSpinner";
import type { RoundDetails } from "@roman/shared/types/RoundDetails";
import { cn } from "@roman/shared/utils";
import { ChevronRight } from "lucide-react";

type ConfirmCreateEntryModalProps = {
  isLoading: boolean;
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm: () => void;
  roundEntryUnit: RoundDetails["roundEntryUnits"][0];
  userPoints: number;
  userNumEntries: number;
};
export const ConfirmCreateEntryModal = ({
  open,
  setOpen,
  onConfirm,
  roundEntryUnit,
  userPoints,
  userNumEntries,
  isLoading,
}: ConfirmCreateEntryModalProps) => {
  const handleOpenChange = (value: boolean) => {
    if (isLoading) return;
    setOpen(value);
  };
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="[&>button]:hidden py-8 w-[350px] md:w-[450px] h-[383px] ring-0 ring-transparent">
        <DialogTitle className="dialog-content text-black text-center font-Inter text-xl font-semibold leading-[30px] max-w-[287px] mx-auto">
          <p>{roundEntryUnit.entryFee}ポイントを使用し</p>
          <p>エントリーを確定しますか</p>
        </DialogTitle>

        <div className="flex justify-center items-center gap-1 bg-gray rounded-full text-black text-lg w-fit mx-auto px-4 py-[5px] font-bold leading-[18px]">
          <ThumbaCoin className="h-6 w-6 space-x-2" />
          <span className="align-middle leading-[18px]">{userPoints}pt</span>
          <ChevronRight className="text-light-gray" />
          <span> {userPoints - Number.parseInt(roundEntryUnit.entryFee)}pt</span>
        </div>

        {roundEntryUnit.maxNumEntriesPerUser && (
          <div className="text-dark-gray text-center text-base font-bold">
            <span>エン トリー回数：</span>
            <span className={cn("text-primary")}>{userNumEntries}</span>
            <span>/{roundEntryUnit.maxNumEntriesPerUser}</span>
          </div>
        )}

        <div className="flex flex-col w-full items-center justify-center mt-5">
          <Button
            className="text-lg w-full py-[25px] text-white rounded-lg font-bold"
            variant="default"
            disabled={isLoading}
            onClick={() => {
              onConfirm();
            }}
          >
            {isLoading ? <LoadingSpinner /> : "エントリーを確定する"}
          </Button>
          <Button
            className="text-base mt-3"
            variant="link"
            onClick={() => {
              if (isLoading) return;
              setOpen(false);
            }}
          >
            閉じる
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
